export const allThemes = [
  {
    name: 'blueEclipse',
    displayName: 'Blue Eclipse',
    logo: 'assets/img/logo.png',
    themeVariables: {
      '--color-primary': '#3A59D1',
      '--icon-color': '#0D1B2A',
      '--text-color-primary': '#000',
      '--color-accent': '#536DFE',
      '--accent-font-color' : '#fff',
      '--color-warn': '#D32F2F',
      '--primaryFontColor': '#000',
      '--LinkColor': '#536DFE',
      '--color-secondary': '#3D90D7',
      '--color-tertiary': '#7AC6D2',
      '--bodyColor': '#FFFFFF',
      '--menuColor': '#FFFFFF',
      '--cardBorderBottomColor': '#0D1B2A',
      '--fgBodyBg': '#fff',
      '--background-highlight-color': 'var(--color-primary)',
      '--background-highlight-font-color': '#fff',
      '--card-bg' : '#FFF'
    },
  },

  {
    name: 'darkMono',
    displayName: 'Dark Mono',
    logo: 'assets/img/logo_white.png',
    themeVariables: {
      '--color-primary': '#212121',
      '--color-secondary': '#36454F',
      '--color-tertiary': '#1B1212',
      '--text-color-primary': '#FFF',
      '--color-accent': '#424242',
      '--accent-font-color' : '#fff',
      '--color-warn': '#616161',
      '--primaryFontColor': '#FFFFFF',
      '--LinkColor': '#E0E0E0',
      '--secondaryColor': '#757575',
      '--tertiaryColor': '#9E9E9E',
      '--bodyColor': '#303030',
      '--menuColor': '#fff',
      '--cardBorderBottomColor': '#616161',
      '--mat-datepicker-calendar-period-button-text-color': '#FFF',
      '--icon-primary': '#fff',
      '--fgBodyBg': 'hsl(232, 11%, 15%)',
      '--icon-color': '#fff',
      '--table-border-color': '#525252',
      '--background-highlight-color': '#fff',
      '--background-highlight-font-color': '#fff',
      '--indicatorColor': '#fff',
      '--text-secondary-color': 'rgba(255, 255, 255, 0.5)',
      '--linkColor':'#58A6FF',
      '--card-bg' : '#303030'
  

    },
  },
];
